import {css, cx} from "@panda/css";

interface IProps {
    children: React.ReactNode;
    className?: string;
}

export const ResponsiveCardBodySimple: React.FC<IProps> = ({className, children}) => <div className={cx(wrapperStyle, className)}>{children}</div>;

const wrapperStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    padding: 2
});
import {css, cx} from "@panda/css";

interface IProps {
    children: React.ReactNode;
    className?: string;
}

export const ResponsiveCardBodySimple: React.FC<IProps> = ({className, children}) => <div className={cx(wrapperStyle, className)}>{children}</div>;

const wrapperStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    padding: 2
});
